// extracted by mini-css-extract-plugin
module.exports = {"managerHeader":"SourceManagerColumn_managerHeader__2Emdm"};